import { render, staticRenderFns } from "./AtencionModalView.vue?vue&type=template&id=507e7310"
import script from "./AtencionModalView.vue?vue&type=script&lang=js"
export * from "./AtencionModalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports